module.exports = __webpack_public_path__ + "media/images/coach-connect-mark-wit-308aad0976da077138aa00ac4610aa55.svg";